import React from 'react'

import workExperience from '../../../assets/work-experience.svg'

import Card from '../../components/Card'
import WorkExperience from '../../containers/WorkExperience'
import SkeletonWorkHistoryScene from '../../skeletons/SkeletonWorkHistoryScene'

import WorkExperienceHeading from '../../components/WorkExperienceHeading'
import NoWorkExperienceForm from '../../components/NoWorkExperienceForm'
import WorkHistoryList, { WorkHistoryItemForm, WorkHistoryItemPreview } from '../../compounds/WorkHistoryList'

const WorkExperienceScene = routeProps => (
  <WorkExperience>
    {props => (
      <Card title="Work history" imageUrl={workExperience} width={550}>
        <WorkExperienceHeading />

        <Choose>
          <When condition={props.loading}>
            <SkeletonWorkHistoryScene />
          </When>

          <Otherwise>
            <WorkHistoryList addBlankWorkHistory={props.addBlankWorkHistory}>
              <For each="workHistory" of={props.workHistories}>
                <Choose>
                  <When condition={workHistory.editing}>
                    <WorkHistoryItemForm
                      key={workHistory.formName}
                      form={workHistory.formName}
                      initialValues={workHistory}
                      isNew={workHistory.isNew}
                      searchCompanies={term => props.searchCompanies(workHistory.id || workHistory.tempId, term)}
                      searchingCompanies={workHistory.searchingCompanies}
                      companiesSearchResults={workHistory.companiesSearchResults}
                      searchRoles={term => props.searchRoles(workHistory.id || workHistory.tempId, term)}
                      searchingRoles={workHistory.searchingRoles}
                      rolesSearchResults={workHistory.rolesSearchResults}
                      toggleEditing={editing => props.toggleEditing(workHistory.id, editing)}
                      deleteBlankWorkHistory={() => props.deleteBlankWorkHistory(workHistory.tempId)}
                      updateWorkHistory={(data, resolve, reject) => props.updateWorkHistory(workHistory.id, data, resolve, reject)}
                      createWorkHistory={props.createWorkHistory}
                    />
                  </When>
                  <Otherwise>
                    <WorkHistoryItemPreview
                      key={workHistory.id}
                      deleteWorkHistory={() => props.deleteWorkHistory(workHistory)}
                      toggleEditing={editing => props.toggleEditing(workHistory.id, editing)}
                      {...workHistory}
                    />
                  </Otherwise>
                </Choose>
              </For>
            </WorkHistoryList>

            <NoWorkExperienceForm
              initialValues={{
                no_work_history: props.candidate.no_work_history,
              }}
              workRecordsAdded={props.hasWorkHistoryRecords}
              isAddingNewRecord={props.isAddingNewWorkHistory}
              clearErrors={props.clearErrors}
              submitWorkExperience={props.submitWorkExperience}
              location={routeProps.location}
              history={routeProps.history}
            />
          </Otherwise>
        </Choose>
      </Card>
    )}
  </WorkExperience>
)

export default WorkExperienceScene
